import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface ExportICSConsignedCsvInterface {
  splitReferance?: string
}

export const useExportICSConsignedCsv = () => {
  const mutate = useMutation(
    ({ splitReferance }: ExportICSConsignedCsvInterface) => {
      console.log('splitReferance', splitReferance)
      return postAPI(`/ICSBulkConsignment/CsvList`, {
        splitReferance: splitReferance,
      })
    },
  )

  return mutate
}

export default useExportICSConsignedCsv
